module.exports = __webpack_public_path__ + "img/map.97f887c1.png";